import React from "react";

function Logo() {
  return (
    <svg
      id="gear"
      fill="none"
      className="App-logo"
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      version="1"
      viewBox="0 0 110 110"
    >
      <g transform="translate(-559.286 -488.79)">
        <g transform="translate(491.785 169.306)"
          fontFamily="Calibre-Medium, Calibre" fontSize="50" fontWeight="400" letterSpacing="4.16666603">
          <path
            style={{ fill: "var(--color-primary)" }}
            d="M176.984 366.951l-9.444-3.157a46.053 46.053 0 00-5.629-13.6l4.442-8.904a55.343 55.343 0 00-10.658-10.657l-8.905 4.442a45.993 45.993 0 00-13.598-5.631l-3.157-9.443a55.567 55.567 0 00-7.535-.516c-2.557 0-5.07.179-7.535.516l-3.157 9.443a46.01 46.01 0 00-13.599 5.631l-8.904-4.442a55.249 55.249 0 00-10.656 10.657l4.442 8.904a45.976 45.976 0 00-5.63 13.6l-9.444 3.157a55.39 55.39 0 000 15.068l9.444 3.157a46.027 46.027 0 005.629 13.6l-4.44 8.904a55.249 55.249 0 0010.656 10.657l8.904-4.442a46.01 46.01 0 0013.599 5.631l3.157 9.442c2.464.338 4.978.517 7.535.517 2.557 0 5.07-.179 7.535-.517l3.157-9.442a46.017 46.017 0 0013.598-5.63l8.905 4.441a55.277 55.277 0 0010.656-10.657l-4.44-8.904a46.053 46.053 0 005.629-13.6l9.444-3.157c.337-2.463.516-4.978.516-7.534a55.39 55.39 0 00-.517-7.534zM122.5 412.075c-20.76 0-37.59-16.829-37.59-37.59 0-20.761 16.83-37.59 37.59-37.59 20.76 0 37.59 16.829 37.59 37.59 0 20.761-16.83 37.59-37.59 37.59z">
          </path>
        </g>
      </g>
    </svg>
  );
}

export default Logo;
